import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePages";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DetailPage from "./pages/DetailPage";
import FirmsPage from "./pages/FirmsPage";
import FirmAddPage from "./pages/FirmAddPage";
import PhotosPage from "./pages/PhotosPage";
import CelebsSivasPage from "./pages/CelebsSivasPage";
import AdminPanel from "./pages/AdminPanel";
import WhatsAppButton from "./components/WhatsappButton";
import FirmDetailPage from "./pages/FirmDetailPage";
import VideosPage from "./pages/VideosPage";
import InterviewsPage from "./pages/InterviewsPage";
import HakkimizdaPage from "./pages/HakkimizdaPage";



const App = () => {
  const [currentPage, setCurrentPage] = useState("home");
  const [selectedCategory, setSelectedCategory] = useState(null);

  const renderMainPage = () => {
    if (currentPage === "home") {
      return (
        <HomePage
          setCurrentPage={setCurrentPage}
          setSelectedCategory={setSelectedCategory}
        />
      );
    }

    if (currentPage === "firms") {
      return (
        <FirmsPage
          selectedCategory={selectedCategory}
          setCurrentPage={setCurrentPage}
        />
      );
    }

    if (currentPage === "hakkimizda") {
      return <HakkimizdaPage setCurrentPage={setCurrentPage} />;
    }

    if (currentPage === "detail") {
      return <DetailPage />;
    }

    if (currentPage === "login") {
      return <LoginPage setCurrentPage={setCurrentPage} />;
    }

    if (currentPage === "register") {
      return <RegisterPage setCurrentPage={setCurrentPage} />;
    }

    if (currentPage === "firmAdd") {
      return <FirmAddPage setCurrentPage={setCurrentPage} />;
    }

    if (currentPage === "photos") {
      return <PhotosPage />;
    }

    if (currentPage === "videos") return <VideosPage />;
    
    if (currentPage === "roportaj") return <InterviewsPage />;

    if (currentPage === "unlulerSivas") {
      return <CelebsSivasPage setCurrentPage={setCurrentPage} />;
    }

    // default
    return (
      <HomePage
        setCurrentPage={setCurrentPage}
        setSelectedCategory={setSelectedCategory}
      />
    );
  };

  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <Navbar setCurrentPage={setCurrentPage} />

        <WhatsAppButton />

        <Routes>
          {/* Normal site: currentPage state ile yönetiliyor */}
          <Route path="/" element={renderMainPage()} />

          {/* Admin için ayrı route */}
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/firms/:id" element={<FirmDetailPage />} />
        </Routes>

        <Footer setCurrentPage={setCurrentPage} />
      </div>
    </Router>
  );
};

export default App;
